export default "__VITE_ASSET__DCIZfgJr__"